import { LanguageUtils } from '@pbt/pbt-ui-components'

import BusinessShareIcon from '~/components/common/icons/BusinessShareIcon'
import type { MasterProblemsSnapshotItem } from '~/types'

import styles from './ProblemsNameCell.module.scss'

interface ProblemsNameCellProps {
  item: MasterProblemsSnapshotItem
}

const ProblemsNameCell = ({ item }: ProblemsNameCellProps) => {
  const name =
    LanguageUtils.getTranslatedFieldName(item, 'description', item.name) || ''

  return (
    <div className={styles.container}>
      <span className={styles.name} title={name}>
        {name}
      </span>
      <BusinessShareIcon
        businessIds={item.businessId ? [item.businessId] : []}
        color="black"
      />
    </div>
  )
}

export default ProblemsNameCell
